"use strict";
if (typeof jQuery === "undefined") {
    throw new Error("jQuery plugins need to be loaded before this file");
}
/**
 * apps
 */
let app = {};
/**
 * alertas para mensajes
 */
app.alertas = {
    /**
     * Crear una alerta de tipo warning
     * @param {string} mensaje Mensaje o contenido de la alerta
     * @param {string} element Identidicador del elemento en el cual va la alerta
     */
    warning: function (mensaje, element) {
        let _mensaje =
            "<div class='alert alert-warning alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>" +
            "<h4><i class='icon fa fa-warning'></i>¡Alerta!</h4>" +
            mensaje +
            "</div>";

        $(element).html(_mensaje);
    },
    /**
     * Crear una alerta de tipo success
     * @param {string} mensaje Mensaje o contenido de la alerta
     * @param {string} element Identidicador del elemento en el cual va la alerta
     */
    success: function (mensaje, element) {
        let _mensaje =
            "<div class='alert alert-success alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>" +
            "<h4><i class='icon fa fa-check'></i>¡Mensaje!</h4>" +
            mensaje +
            "</div>";

        $(element).html(_mensaje);
    },
    /**
     * Crear una alerta de tipo error
     * @param {string} mensaje Mensaje o contenido de la alerta
     * @param {string} element Identidicador del elemento en el cual va la alerta
     */
    error: function (mensaje, element) {
        let _mensaje =
            "<div class='alert alert-danger alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>" +
            "<h4><i class='icon fa fa-ban'></i>¡Error!</h4>" +
            mensaje +
            "</div>";

        $(element).html(_mensaje);
    },
    /**
     * Crear una alerta de tipo información
     * @param {string} mensaje Mensaje o contenido de la alerta
     * @param {string} element Identidicador del elemento en el cual va la alerta
     */
    info: function (mensaje, element) {
        let _mensaje =
            "<div class='alert alert-info alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;</button>" +
            "<h4><i class='icon fa fa-info'></i>Información:</h4>" +
            mensaje +
            "</div>";

        $(element).html(_mensaje);
    },
};

app.randomKey = () => {
    let array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0];
};
app.roundNumber = function (num, scale) {
    var number = Math.round(num * Math.pow(10, scale)) / Math.pow(10, scale);
    if (num - number > 0) {
        return parseFloat(
            number +
                Math.floor((2 * Math.round((num - number) * Math.pow(10, scale + 1))) / 10) /
                    Math.pow(10, scale)
        );
    } else {
        return parseFloat(number);
    }
};
let _alerta;
app.confirmacion = {
    /**
     *
     * @param {object} data info
     * @param {string} data.title Título alerta
     * @param {string} data.mensaje mensaje alerta
     * @param {string} data.boton botón alerta
     * @param {any} callback function de llamado
     */
    aceptar: function (data, callback) {
        if (typeof $.confirm !== "undefined") {
            if (typeof _alerta !== "undefined" && _alerta !== null) {
                _alerta.close();
            }
            alerta = $.confirm({
                type: "green",
                title: data.title,
                content: data.mensaje,
                draggable: false,
                buttons: {
                    confirm: {
                        text: data.boton,
                        btnClass: "btn-success",
                        action: function () {
                            if (typeof callback !== "undefined") {
                                callback();
                            }
                        },
                    },
                    cancel: {
                        text: "Cancelar",
                    },
                },
            });
        }
    },
    /**
     *
     * @param {object} data info
     * @param {string} data.title Título alerta
     * @param {string} data.mensaje mensaje alerta
     * @param {string} data.boton botón alerta
     * @param {any} callback function de llamado
     */
    eliminar: function (data, callback) {
        if (typeof $.confirm !== "undefined") {
            if (typeof _alerta !== "undefined" && _alerta !== null) {
                _alerta.close();
            }
            $.confirm({
                type: "red",
                title: data.title,
                content: data.mensaje,
                draggable: false,
                buttons: {
                    confirm: {
                        text: data.boton,
                        btnClass: "btn-danger",
                        action: function () {
                            if (typeof callback !== "undefined") {
                                callback();
                            }
                        },
                    },
                    cancel: {
                        text: "Cancelar",
                    },
                },
            });
        }
    },
};
/**
 *
 * @param {HTMLFormElement} form
 */
app.formElementToObject = function (form) {
    let object = {};
    if (!(form instanceof HTMLFormElement)) {
        return object;
    }
    const formData = new FormData(form);
    formData.forEach(function (value, key) {
        if (!Reflect.has(object, key)) {
            object[key] = value;
            return;
        }
        if (!Array.isArray(object[key])) {
            object[key] = [object[key]];
        }
        object[key].push(value);
    });
    return object;
};
